import { defineStore } from "pinia";
import { ref, onMounted } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "industrySector";

export const useIndustrySectorStore = defineStore(storeName, () => {
  const all = ref([]);

  const { baseFetchAll, watchRemoteResourceChange } = useBase(storeName);

  const fetchAll = async (errorCallback) => {
    all.value = await baseFetchAll("industry-sectors", errorCallback);
  };

  onMounted(async () => {
    await fetchAll();
    await watchRemoteResourceChange(storeName, () => {
      fetchAll();
    });
  });

  return {
    industrySectors: all,
    fetchIndustrySectors: fetchAll
  };
});
